import React from "react";

const OurStory = () => {
  return (
    <section className="max-w-7xl mx-auto text-lg text-justify px-6 py-12 md:px-20 lg:px-40">
      <h2 className="text-3xl text-gray-800 mb-4 text-center font-bold">
        Our Journey
      </h2>
      <p className="text-gray-700 mb-6">
        <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span> was born from
        a simple yet ambitious vision: to create more than just an online store,
        but a hub for tech enthusiasts seeking cutting-edge innovation. Our
        journey began with a passion for the latest gadgets, a fascination with
        emerging technology, and a drive to bring the best electronic devices to
        those who crave excellence.
      </p>
      <p className="text-gray-700 mb-6">
        Our founders, fueled by their love for technology, saw the need for a
        dedicated platform where people could explore, compare, and purchase
        top-tier gadgets effortlessly. They envisioned a space that offers not
        just premium products, but an experience—one that inspires and enhances
        everyday life.
      </p>
      <p className="text-gray-700 mb-6">
        At <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>, every
        product is handpicked to ensure quality, performance, and innovation.
        From smartphones and smartwatches to high-fidelity audio gear and gaming
        accessories, we curate only the best to match your lifestyle. For us,
        technology is more than just convenience—it’s about pushing boundaries,
        making connections, and redefining possibilities.
      </p>
      <p className="text-gray-700 mb-6">
        Today, <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>{" "}
        continues to grow, staying committed to delivering the latest and
        greatest in tech. We believe in quality, authenticity, and a
        customer-first approach, making sure every interaction with us is as
        seamless and exciting as the gadgets we offer.
      </p>
      <p className="text-gray-700">
        Welcome to <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>
        —where technology meets passion, and every product is a step into the
        future.
      </p>
    </section>
  );
};

export default OurStory;
